import axios from '@/axios/axios2'

// 获取个人信息
export const getUserInfo = params => axios.post('/api/app/me.do', params)

// 增量奖预估值总数
export const getAllIncrementAmount = params =>
  axios.post('/partner/getAllIncrementAmount', params)

// 增量奖预估
export const getIncrementAmount = params =>
  axios.post('/partner/getIncrementAmount', params)
